"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
function last(seq) {
    var result;
    var iter = seq.next();
    while (!iter.done) {
        result = iter.value;
        iter = seq.next();
    }
    return result;
}
exports.last = last;
function first(seq) {
    var iter = seq.next();
    return iter.done ? undefined : iter.value;
}
exports.first = first;
function skip(seq, n) {
    var i, iter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                i = 0;
                iter = seq.next();
                _a.label = 1;
            case 1:
                if (!!iter.done) return [3 /*break*/, 4];
                if (!(i >= n)) return [3 /*break*/, 3];
                return [4 /*yield*/, iter.value];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                iter = seq.next();
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
exports.skip = skip;
function take(seq, n) {
    var i, iter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                i = 0;
                iter = seq.next();
                _a.label = 1;
            case 1:
                if (!!iter.done) return [3 /*break*/, 3];
                if (i >= n) {
                    return [3 /*break*/, 3];
                }
                return [4 /*yield*/, iter.value];
            case 2:
                _a.sent();
                iter = seq.next();
                i++;
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
exports.take = take;
function map(src, f) {
    var src_1, src_1_1, x, e_1_1;
    var e_1, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, 6, 7]);
                src_1 = __values(src), src_1_1 = src_1.next();
                _b.label = 1;
            case 1:
                if (!!src_1_1.done) return [3 /*break*/, 4];
                x = src_1_1.value;
                return [4 /*yield*/, f(x)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                src_1_1 = src_1.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1_1 = _b.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (src_1_1 && !src_1_1.done && (_a = src_1.return)) _a.call(src_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
exports.map = map;
function reduce(src, r, s) {
    var e_2, _a;
    var result = s;
    try {
        for (var src_2 = __values(src), src_2_1 = src_2.next(); !src_2_1.done; src_2_1 = src_2.next()) {
            var x = src_2_1.value;
            result = r(result, x);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (src_2_1 && !src_2_1.done && (_a = src_2.return)) _a.call(src_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return result;
}
exports.reduce = reduce;
function filter(src, f) {
    var src_3, src_3_1, x, e_3_1;
    var e_3, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, 6, 7]);
                src_3 = __values(src), src_3_1 = src_3.next();
                _b.label = 1;
            case 1:
                if (!!src_3_1.done) return [3 /*break*/, 4];
                x = src_3_1.value;
                if (!f(x)) return [3 /*break*/, 3];
                return [4 /*yield*/, x];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                src_3_1 = src_3.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_3_1 = _b.sent();
                e_3 = { error: e_3_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (src_3_1 && !src_3_1.done && (_a = src_3.return)) _a.call(src_3);
                }
                finally { if (e_3) throw e_3.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
exports.filter = filter;
function asArray(src) {
    var e_4, _a;
    var result = [];
    try {
        for (var src_4 = __values(src), src_4_1 = src_4.next(); !src_4_1.done; src_4_1 = src_4.next()) {
            var e = src_4_1.value;
            result.push(e);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (src_4_1 && !src_4_1.done && (_a = src_4.return)) _a.call(src_4);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return result;
}
exports.asArray = asArray;
function reverse(src) {
    var arr, reversed, reversed_1, reversed_1_1, e, e_5_1;
    var e_5, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                arr = asArray(src);
                reversed = arr.reverse();
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, 7, 8]);
                reversed_1 = __values(reversed), reversed_1_1 = reversed_1.next();
                _b.label = 2;
            case 2:
                if (!!reversed_1_1.done) return [3 /*break*/, 5];
                e = reversed_1_1.value;
                return [4 /*yield*/, e];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                reversed_1_1 = reversed_1.next();
                return [3 /*break*/, 2];
            case 5: return [3 /*break*/, 8];
            case 6:
                e_5_1 = _b.sent();
                e_5 = { error: e_5_1 };
                return [3 /*break*/, 8];
            case 7:
                try {
                    if (reversed_1_1 && !reversed_1_1.done && (_a = reversed_1.return)) _a.call(reversed_1);
                }
                finally { if (e_5) throw e_5.error; }
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}
exports.reverse = reverse;
function asIter(a) {
    var a_1, a_1_1, v, e_6_1;
    var e_6, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, 6, 7]);
                a_1 = __values(a), a_1_1 = a_1.next();
                _b.label = 1;
            case 1:
                if (!!a_1_1.done) return [3 /*break*/, 4];
                v = a_1_1.value;
                return [4 /*yield*/, v];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                a_1_1 = a_1.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_6_1 = _b.sent();
                e_6 = { error: e_6_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (a_1_1 && !a_1_1.done && (_a = a_1.return)) _a.call(a_1);
                }
                finally { if (e_6) throw e_6.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}
exports.asIter = asIter;
function chunks(src, chunkSize) {
    var chunk, src_5, src_5_1, v, e_7_1;
    var e_7, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                chunk = [];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, 7, 8]);
                src_5 = __values(src), src_5_1 = src_5.next();
                _b.label = 2;
            case 2:
                if (!!src_5_1.done) return [3 /*break*/, 5];
                v = src_5_1.value;
                chunk.push(v);
                if (!(chunk.length === chunkSize)) return [3 /*break*/, 4];
                return [4 /*yield*/, asIter(chunk)];
            case 3:
                _b.sent();
                chunk = [];
                _b.label = 4;
            case 4:
                src_5_1 = src_5.next();
                return [3 /*break*/, 2];
            case 5: return [3 /*break*/, 8];
            case 6:
                e_7_1 = _b.sent();
                e_7 = { error: e_7_1 };
                return [3 /*break*/, 8];
            case 7:
                try {
                    if (src_5_1 && !src_5_1.done && (_a = src_5.return)) _a.call(src_5);
                }
                finally { if (e_7) throw e_7.error; }
                return [7 /*endfinally*/];
            case 8:
                if (!chunk.length) return [3 /*break*/, 10];
                return [4 /*yield*/, asIter(chunk)];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}
exports.chunks = chunks;
//# sourceMappingURL=iterator.js.map